module.exports = __webpack_public_path__ + "assets/img/box1-3.ea0e542e.svg";